import { bl_sfa_stage_hdr_RowClass } from "../../dbschema/bl_sfa_stage_hdr.model";
import { BaseContainerModel } from "../base-container.model";

export class SfaStageContainerModel extends BaseContainerModel {
	bl_sfa_stage_hdr: bl_sfa_stage_hdr_RowClass =
		new bl_sfa_stage_hdr_RowClass();
}
